import { LoadableAfterPaint } from '@confluence/loadable';

export const SiteAnalyticsPageLoader = LoadableAfterPaint({
	loader: async () =>
		(
			await import(
				/* webpackChunkName: "loadable-componentsSiteAnalyticsPage" */ '../src/components/SiteAnalytics/SiteAnalyticsPage'
			)
		).SiteAnalyticsPage,
});
